import script from "./FilesActions.vue?vue&type=script&lang=js"
export * from "./FilesActions.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__